import { createFileRoute } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';
import * as DataIngestion from '@mint-sdk/api-data-ingestion';

import { PendingComponent } from '@myn/import-hub/routes';

const dataFilePreloadGuard = buildGuards(hasFlagEnabled('dataFilePreload'));

export const Route = createFileRoute(
  '/_secured/company-profile/import-hub/performance/imports/$dataFileId/header-selection',
)({
  staleTime: 30 * 1000,
  loader: async ({ context, params, cause }) => {
    const armGuardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@mint/arm'),
    );

    if (!dataFilePreloadGuard(armGuardsContext) || cause !== 'preload') {
      return;
    }

    const queryClient =
      await context.serviceLocator.getOrThrowInstance('queryClient');

    queryClient.prefetchQuery(
      DataIngestion.DataFile.getDataFileFormatsQueryOptions({
        urlParams: { id: params.dataFileId },
      }),
    );

    queryClient.prefetchQuery({
      ...DataIngestion.DataFile.getHeadersFormatsOptionsQueryOptions({}),
    });

    queryClient.prefetchQuery(
      DataIngestion.DataFile.getDataFilePreviewRowsQueryOptions({
        urlParams: { id: params.dataFileId },
      }),
    );
  },
  pendingComponent: PendingComponent,
});
